import { render, staticRenderFns } from "./page-legal.vue?vue&type=template&id=17f80b86&scoped=true"
import script from "./page-legal.vue?vue&type=script&lang=js"
export * from "./page-legal.vue?vue&type=script&lang=js"
import style0 from "./page-legal.vue?vue&type=style&index=0&id=17f80b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f80b86",
  null
  
)

export default component.exports